module.exports = __webpack_public_path__ + "img/bj-exam.c06f0d4a.png";